import { AppValueTypes, AttributeValueRange, CoreApplicationObjectType, GPS_Data } from '@iotv/iotv-v3-types'
import { ValidModelType } from '../classDependentTypes/ValidModelClasses'
import { PathDirection } from '../types/DatastoreEnums'
import { MapLike, PossibleBusinessObject, ValidBusinessObject, ValueTypes } from '@iotv/iotv-v3-types'

export enum AttributeMode {
  'readOnly',
  'readWrite',
}

export type ValidationDef = {
  regex?: RegExp | string
  /** if pass is true, validation is OK when regex returns a match, if false, validation FAILS when regex return a match. consumers should Default to true when non extant */
  pass?: boolean
  invalidMessage?: string
}

export type EdgeAttributesType = {
  key: string
  type: AppValueTypes
}

// RelatedType, Enum are new in UI-2
// Derived is currently only UI-1
export type UserAttributeDefinitionType = 'String' | 'Number' | 'RelatedType' | 'Enum' | 'Derived' | 'Date' | 'Boolean' | 'Array' | 'object' | 'Attribute'

export type CardinalityType = {
  out: number | null
  in: number | null
}

export enum UserAttributeKeyDatePrecision {
  Date,
  DateTimeMins,
  DateTimeSecs,
  Duration,
}

export type UserAttributeDefKeys = {
  type: UserAttributeDefinitionType
  direction?: PathDirection
  objectTypeId?: ValidModelType
  edgeTypeId?: string
  /** @deprecated AS UNUSED DUE FOR DEPECATION - ALL EXTERNAL PROJECTS NEEED THIS REMOVING */
  name?: string
  description?: string
  label?: string | Function
  validation?: ValidationDef
  limits?: AttributeValueRange
  units?: string
  precision?: number
  /** UI components should use this in validation. If the setting is true, the field must be populated to save */
  required?: boolean
  editable?: boolean
  needConfirmation?: boolean
  mode?: AttributeMode
  enumKv?: { [k: string | number]: string }
  cardinality?: CardinalityType
  valueFn?: Function
  displayFn?: Function
  viewName?: string
  actions?: { create?: boolean; link?: boolean; edit?: boolean; delete?: boolean }
  default?: ValueTypes
}

export type UserAttributeDef = UserAttributeDefKeys | undefined

export type ConstrainedUserAttDefs<T> = Omit<{ [k in keyof T]: UserAttributeDef }, keyof CoreApplicationObjectType>

export type UserAttributeDefs = { [k: string]: UserAttributeDef }

export type AlertStatus = {
  NOT_SET: string
  NO_ALERT: string
  ISSUED_NO_ACK: string
  ISSUED_ACKNOWLEDGED: string
  RESOLVED: string
  CANCELLED: string
}

export type MapObject = { [k: string]: any }

export type AlertStateusKeys = keyof AlertStatus

export type GeofencePointsType = { lat: number; lng: number; id?: string; timestamp?: number; annotation?: string } & Partial<
  Pick<GPS_Data, 'DOP' | 'heading' | 'speed'>
>

export function isGeofencePointsType(ob: any | undefined): ob is GeofencePointsType {
  return ob && typeof ob.lat === 'number' && typeof ob.lng === 'number' && Math.abs(ob.lat) <= 90 && Math.abs(ob.lng) <= 180
}

export interface GeofenceType extends ValidBusinessObject {
  Geofence?: GeofenceType[]
  points: GeofencePointsType[]
}

// export type { ValidationDef, UserAttributeDef, UserAttributeDefs, AlertStatus, AlertStateusKeys, MapObject}
// export type { GeofenceType, GeofencePointsType }
// export { mode }

export enum CustomerAccountType {
  V = 'Venture',
  X = 'Reseller',
  Y = 'Service Consumer / Reseller',
  Z = 'Service Consumer',
}

export type ICustomer = {
  [k in keyof PossibleBusinessObject]: PossibleBusinessObject[k]
} & {
  accountType?: CustomerAccountType
}

export type CustomerProps = {
  accountType?: CustomerAccountType
  type: string
} & MapLike<any>

export type UserProps = {
  name: string
  username: string
  email: string
  phoneNumber: string
  temporaryPassword?: string
}
